import React, { useState, useEffect, useRef } from "react";
import { Row, Col } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
import { FormattedMessage } from 'react-intl';

import CorrespondantGetter from '../../Controller/getCorrespondant.js';

const DeleteCorrespondantPopup = (props) => {
  const { classes } = props;

  const checkDelete = async () => {
    await CorrespondantGetter.dissociate_Correspondant(props.FK_structure, props.patient_data)
    props.cancelPopup()
  }

  return (
    <div className={classes.popup_background}>
      <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
        <div className="submit-form" style={{ borderRadius: "5px"}}>
	        <div className="form-group" style={{paddingTop:"5%"}}>
            <FormattedMessage id="correspondant.deleteVerification" defaultMessage="Are you sure you want to dissociate the correspondant?" />
	        </div>
        	<button onClick={props.cancelPopup} className="btn btn-danger">
            	<FormattedMessage id="button.cancel" defaultMessage="Cancel" />
          	</button>
        	<button onClick={checkDelete} className="btn btn-success">
        		<FormattedMessage id="button.submit" defaultMessage="Submit" />
        	</button>
        </div>
      </div>
    </div>
  );
}

export default withStyles(Constants.styles)(DeleteCorrespondantPopup);